import { SxProps, Theme } from '@mui/material';

export const imagePromotionSX: SxProps<Theme> = {
	maxWidth: { xs: '100%', md: '300px' },
	height: {
		xs: 'auto',
		sm: '200px',
	},
	borderRadius: '4px',
};

export const titlePromotionSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	fontWeight: 'bold',
	color: '#263645',
};

export const linkPromotionSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	letterSpacing: '0px',
	color: '#263645',
	fontWeight: 'normal',
	opacity: 1,
	textDecoration: 'none',

	'&:hover': {
		textDecoration: 'none',
	},
};
